import cleanedFilename from '~/util/cleanedFilename';

export default {
  EXIST_SWITCHER: `${cleanedFilename(__filename)}-exist-switcher`,
};
